import React from "react";
import Modal from "react-bootstrap/Modal";
import { BsMailbox2Flag } from "react-icons/bs";
import TimesheetReminder from "../components/TimesheetReminder";

const TimesheetReminderModal = ({ visible, close, shift, updateShift }) => {
  return (
    <Modal
      show={visible}
      onHide={close}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          id="contained-modal-title-vcenter"
          className={"text-capitalize"}
        >
          <h1 className={"text-axis-offblack icon-text-wrapper"}>
            <BsMailbox2Flag />
            Send Timesheet Reminder
          </h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <TimesheetReminder
          shift={shift}
          onComplete={(s) => {
            updateShift(s);
            close();
          }}
          close={close}
        />
      </Modal.Body>
    </Modal>
  );
};

export default TimesheetReminderModal;
